<template>
  <VueFinalModal
    :esc-to-close="true"
    class="flex justify-center items-center"
    content-class="relative flex flex-col w-[90vw] h-[90vh] mx-auto bg-white border rounded-lg"
  >
    <!-- Close button -->
    <button
      @click="closeModal"
      class="absolute top-2 right-2 md:top-4 md:right-4 p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors duration-200 z-10"
      :title="t('modals.view_only_target_area.close')"
      aria-label="Close"
    >
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
    
    <div class="flex flex-col h-full max-h-[90vh] w-full">
      <div class="flex-1 min-h-0 overflow-y-auto">
        <TargetArea 
          v-if="params.kestrelEnabled" 
          :target_area_data="params.data"
          :view-only="true"
        />
        
        <div v-else class="flex items-center justify-center h-full">
          <div class="text-center">
            <div class="text-gray-500 mb-4">
              <svg class="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-1.447-.894L15 4m0 13V4m-6 3l6-3"></path>
              </svg>
            </div>
            <h3 class="text-lg font-medium text-gray-900 mb-2">
              {{ t('modals.view_only_target_area.kestrel_map_not_available') }}
            </h3>
            <p class="text-gray-600">
              {{ t('modals.view_only_target_area.kestrel_map_not_available_description') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </VueFinalModal>
</template>

<script setup>
  import { VueFinalModal } from 'vue-final-modal'
  import TargetArea from '@components/kestrel/v2/TargetArea.vue'
  import i18n from '@utils/i18n'

  const { t } = i18n.global

  const props = defineProps({
    params: Object,
  })

  const emit = defineEmits(['close'])

  function closeModal() {
    emit('close')
  }

</script>

<style scoped>
</style> 